export const RECEIVE_CAMPAIGN = 'RECEIVE_CAMPAIGN';
export const RECEIVE_CURRENT_STORE = 'RECEIVE_CURRENT_STORE';
export const RECEIVE_ALL_PROMOTIONS = 'RECEIVE_ALL_PROMOTIONS';
export const MAKE_CAMPAIGN_PROMOTION_ASSOCIATION = 'MAKE_CAMPAIGN_PROMOTION_ASSOCIATION';
export const RECEIVE_COUPONS_FOR_CAMPAIGN = 'RECEIVE_COUPONS_FOR_CAMPAIGN';
